export default {
    props: {
        tooltipBackground: {
            type: String,
            kComposite: 'tooltip.background'
        }, 
        tooltipBorderColor: {
            type: String,
            kComposite: 'tooltip.border.color'
        }, 
        tooltipBorderWidth: {
            type: Number,
            kComposite: 'tooltip.border.width'
        }, 
        tooltipColor: {
            type: String,
            kComposite: 'tooltip.color'
        }, 
        tooltipFont: {
            type: String,
            kComposite: 'tooltip.font'
        }, 
        tooltipFormat: {
            type: String,
            kComposite: 'tooltip.format'
        }, 
        tooltipPadding: {
            type: Number | Object,
            kComposite: 'tooltip.padding'
        }, 
        tooltipTemplate: {
            type: String | Function,
            kComposite: 'tooltip.template'
        }, 
        tooltipVisible: {
            type: Boolean,
            kComposite: 'tooltip.visible'
        }, 
        tooltipShared: {
            type: Boolean,
            kComposite: 'tooltip.shared'
        }, 
        tooltipSharedTemplate: {
            type: String,
            kComposite: 'tooltip.sharedTemplate'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoSparkline/Tooltip.js